var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 418,
    viewBox: "0 0 320 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.794 -106.348C675.234 -52.7324 678.524 2.0045 677.517 57.61C676.528 112.256 683.497 173.126 651.971 215.391C620.8 257.179 559.055 254.264 513.192 277.912C468.549 300.931 435.736 363.998 385.415 352.834C332.528 341.101 310.583 272.785 279.463 226.058C258.576 194.696 259.851 151.612 233.57 124.841C190.632 81.1006 108.163 83.2977 83.8143 26.756C61.9981 -23.9057 101.167 -78.6305 125.84 -125.332C151.102 -173.148 176.19 -232.49 227.798 -245.778C280.614 -259.377 329.804 -186.806 384.416 -191.91C453.585 -198.376 500.703 -298.834 568.474 -277.623C629.084 -258.653 637.576 -168.503 657.794 -106.348Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.772 -109.175C672.769 -61.1936 674.53 -11.8612 672.259 38.3582C670.027 87.711 675.075 142.491 644.63 181.399C614.529 219.868 556.954 218.715 513.57 241.161C471.34 263.009 439.196 320.726 392.484 311.853C343.39 302.528 324.538 241.384 296.603 199.949C277.854 172.139 280.077 133.216 256.182 109.679C217.143 71.2227 140.097 75.1809 118.719 24.7235C99.5649 -20.4866 137.443 -70.8248 161.596 -113.574C186.325 -157.342 211.169 -211.511 259.668 -224.741C309.303 -238.282 353.488 -173.95 404.596 -179.866C469.327 -187.359 515.722 -279.171 578.484 -261.646C634.615 -245.974 640.385 -164.799 657.772 -109.175Z",
    fill: "#008894"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.0f0e87e7ae08d78ed3f81acf5a33659f.svg";
export { ForwardRef as ReactComponent };